import React from "react";
import { VsiH4 } from "../../../styled/App.styled";
import { useTitleFromComponent } from "../../../utils/hooks";

export default function Backup({ title }) {
  useTitleFromComponent(title);
  return (
    <div>
      <VsiH4>Backup</VsiH4>
    </div>
  );
}
